/**
 * Delete notification documents (arbitium_notifications).
 * Blueprint: arbitium_notifications.json
 */

import { deleteRingDoc } from '../core';

const RING_NOTIFICATIONS = 'arbitium_notifications';

/**
 * Deletes a notification by id. Returns true on success.
 */
export async function deleteNotification(notificationId: string): Promise<boolean> {
  const res = await deleteRingDoc(RING_NOTIFICATIONS, notificationId);
  return res.success;
}
